interface IModuloCheck {
    isValid(healthCardNumber: string): boolean;
}

abstract class ModuloCheck implements IModuloCheck {
    public isValid(healthCardNumber: string): boolean {
        if (healthCardNumber === null || healthCardNumber.length !== this.multipliers.length)
            return false;

        let sum = 0;
        for (let i = 0; i < healthCardNumber.length; i++) {
            const digit = Number(healthCardNumber[i]);
            sum += this.applyFormula(digit * this.multipliers[i]);
        }

        return sum % this.moduloValue === 0;
    }

    protected abstract get multipliers(): number[];
    protected abstract get moduloValue(): number;
    protected abstract applyFormula(multiplicationResult: number): number;

}

function SumOfDigits(num: number): number {
    let absValue = Math.abs(num);
    let result = 0;
    while (absValue > 0) {
        result += absValue % 10;
        absValue = Math.floor(absValue / 10);
    }
    return result;
};

class OntarioModuloCheck extends ModuloCheck {
    protected get multipliers(): number[] {
        return [2, 1, 2, 1, 2, 1, 2, 1, 2, 1];
    }

    protected get moduloValue(): number {
        return 10;
    }

    protected applyFormula(multiplicationResult: number): number {
        return SumOfDigits(multiplicationResult);
    }
}

export class OntarioHealthCardNumberValidator {
    private readonly regex = /^([0-9]{4})([0-9]{3})([0-9]{3})([A-Z]{2}){0,1}$/;

    private readonly moduloCheck = new OntarioModuloCheck();

    public isValid(cardNumber: string) {
        if (!this.regex.test(cardNumber))
            return false;

        const numberToVerify = cardNumber
            .substring(0, 10);

        return this.moduloCheck.isValid(numberToVerify);
    }
}


// WEBPACK FOOTER //
// ./src/services/Validator/HealthCard/OntarioOhipNumberValidator.ts